import { render, staticRenderFns } from "./Treeview.vue?vue&type=template&id=23140118&scoped=true&"
import script from "./Treeview.vue?vue&type=script&lang=js&"
export * from "./Treeview.vue?vue&type=script&lang=js&"
import style0 from "./Treeview.vue?vue&type=style&index=0&id=23140118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23140118",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VIcon,VProgressCircular,VTreeview})
